module.exports = __webpack_public_path__ + "static/ServiceProvider-b58493fd5c97a52e236aab47ea5af167.png";